// /var/www/oszczedzam/client/src/hooks/useBudgets.js
import { useState, useEffect } from 'react';
import { database } from '../firebase';
import { ref, push, get, update, remove } from 'firebase/database';
import { useAuth } from '../contexts/AuthContext';

export function useBudgets() {
  const [budgets, setBudgets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentUser } = useAuth();

  // Pobierz wszystkie budżety
  const fetchBudgets = async () => {
    if (!currentUser) {
      setLoading(false);
      return;
    }
    
    try {
      setLoading(true);
      const budgetsRef = ref(database, `users/${currentUser.uid}/budgets`);
      const snapshot = await get(budgetsRef);
      
      const budgetsData = [];
      
      if (snapshot.exists()) {
        snapshot.forEach((childSnapshot) => {
          budgetsData.push({
            id: childSnapshot.key,
            ...childSnapshot.val()
          });
        });
      }
      
      setBudgets(budgetsData);
      setError(null);
    } catch (err) {
      console.error("Błąd podczas pobierania budżetów:", err);
      setError('Nie udało się pobrać budżetów.');
    } finally {
      setLoading(false);
    }
  };

  // Dodaj nowy budżet
  const addBudget = async (budgetData) => {
    if (!currentUser) return null;
    
    try {
      const budgetsRef = ref(database, `users/${currentUser.uid}/budgets`);
      const newBudgetRef = await push(budgetsRef, {
        ...budgetData,
        createdAt: new Date().toISOString()
      });
      
      const newBudget = {
        id: newBudgetRef.key,
        ...budgetData,
        createdAt: new Date().toISOString()
      };
      
      setBudgets([...budgets, newBudget]);
      return newBudget;
    } catch (err) {
      console.error("Błąd podczas dodawania budżetu:", err);
      throw err;
    }
  };

  // Zaktualizuj budżet
  const updateBudget = async (budgetId, budgetData) => {
    if (!currentUser) return null;
    
    try {
      const budgetRef = ref(database, `users/${currentUser.uid}/budgets/${budgetId}`);
      await update(budgetRef, {
        ...budgetData,
        updatedAt: new Date().toISOString()
      });
      
      const updatedBudgets = budgets.map(b => 
        b.id === budgetId 
          ? { ...b, ...budgetData, updatedAt: new Date().toISOString() } 
          : b
      );
      
      setBudgets(updatedBudgets);
      return { id: budgetId, ...budgetData };
    } catch (err) {
      console.error("Błąd podczas aktualizacji budżetu:", err);
      throw err;
    }
  };

  // Usuń budżet
  const deleteBudget = async (budgetId) => {
    if (!currentUser) return false;
    
    try {
      const budgetRef = ref(database, `users/${currentUser.uid}/budgets/${budgetId}`);
      await remove(budgetRef);
      
      setBudgets(budgets.filter(b => b.id !== budgetId));
      return true;
    } catch (err) {
      console.error("Błąd podczas usuwania budżetu:", err);
      throw err;
    }
  };

  // Pobierz budżety przy pierwszym renderowaniu
  useEffect(() => {
    fetchBudgets();
  }, [currentUser]);

  return {
    budgets,
    loading,
    error,
    fetchBudgets,
    addBudget,
    updateBudget,
    deleteBudget
  };
}